module.exports = __webpack_public_path__ + "static/media/al.4ed11fa4.svg";